<template>
  <div class="tool">
    <nav>
      <div class="item" v-for="tool in indexData.menus" :key="tool.id + 'tool'">
        <router-link
          :to="tool.url"
          v-if="
            tool.url.indexOf('http') == -1 &&
            tool.url.indexOf('com') == -1 &&
            tool.url.indexOf('cn') == -1
          "
        >
          <img :src="tool.pic" :alt="tool.name" :title="tool.name" />
          <p>{{ tool.name }}</p>
        </router-link>
        <a :href="tool.url" v-else>
          <img :src="tool.pic" :alt="tool.name" :title="tool.name" />
          <p>{{ tool.name }}</p>
        </a>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: "ToolCom",
  props: {
    indexData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      toolList: [
        {
          id: 1,
          img: require("@/static/images/zhinan.png"),
          title: "新手指南",
          href: "/guide",
        },
        {
          id: 3,
          img: require("@/static/images/dingzhi.png"),
          title: "定制类",
          href: "/custom",
        },
        {
          id: 4,
          img: require("@/static/images/jifen.png"),
          title: "积分商城",
          href: "/pointsMall/",
        },
      ],
    };
  },
  methods: {
    jump(e) {
      if (e.url.indexOf("http") >= 0) {
        window.location = e.url;
      } else {
        this.$router.push({ path: e.url });
      }
    },
  },
};
</script>
